export const supportsPointerEvents = Boolean(window.PointerEvent);

export const pointerDownEvent = supportsPointerEvents ? 'pointerdown' : 'mousedown';

export const getPointerListener = <ListenerType>(listener: ListenerType) =>
  supportsPointerEvents ? listener : undefined;

export const getMouseFallbackListener = <ListenerType>(listener: ListenerType) =>
  supportsPointerEvents ? undefined : listener;
